<template>
  <div class="box-container">
    <d-header
      :breadcrumbs="false"
      fluid
    >
      <h2 class="title is-5">
        <d-previous-btn :path="'/owners/' + model.id + '/contacts'" />
        {{ $t("new_owner_contacts").capitalize() }}
      </h2>
    </d-header>

    <v-form
      ref="form"
      :owner_id="model.id"
      action="create"
    />
  </div>
</template>

<script>
import form from "./_form.vue";
export default {
  components: {
    "v-form": form
  },
  props: {
    model: {
      default: null,
      type: Object
    }
  }
};
</script>
